import { render, staticRenderFns } from "./xTableColumn.vue?vue&type=template&id=1af26a53"
import script from "./xTableColumn.vue?vue&type=script&lang=js"
export * from "./xTableColumn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports